import React, { ComponentProps, FC, useMemo } from 'react';

import {
  DocumentEmptyIcon,
  DocumentPdfIcon,
  DocumentPictureIcon,
  DocumentSpreadsheetIcon,
  DocumentTextIcon,
  DocumentVideoIcon,
  DocumentZipIcon,
  Icon,
} from '@adsk/alloy-react-icon';

import { getAttachmentType } from '../../api/attachments';

type AttachmentItemIconProps = ComponentProps<typeof Icon> & {
  name: string;
};

const FILE_TYPES = {
  IMAGE: 'image',
  TEXTFILE: 'textfile',
  DOCX: 'docx',
  PDF: 'pdf',
  VIDEO: 'video',
  SPREAD_SHEET: ['xls', 'xlsx', 'xltx'],
  ARCHIVE: 'archive',
};

const AttachmentItemIcon: FC<AttachmentItemIconProps> = ({
  name,
  ...props
}) => {
  const type = useMemo(() => getAttachmentType(name), [name]);

  if (type === FILE_TYPES.IMAGE) {
    return <DocumentPictureIcon {...props} />;
  } else if ([FILE_TYPES.TEXTFILE, FILE_TYPES.DOCX].includes(type)) {
    return <DocumentTextIcon {...props} />;
  } else if (type === FILE_TYPES.PDF) {
    return <DocumentPdfIcon {...props} />;
  } else if (type === FILE_TYPES.VIDEO) {
    return <DocumentVideoIcon {...props} />;
  } else if (FILE_TYPES.SPREAD_SHEET.includes(type)) {
    return <DocumentSpreadsheetIcon {...props} />;
  } else if (type === FILE_TYPES.ARCHIVE) {
    return <DocumentZipIcon {...props} />;
  }

  return <DocumentEmptyIcon {...props} />;
};

export default AttachmentItemIcon;
